import React, { useEffect, useState, useCallback } from "react";
import CommonLayout from "../../layout/CommonLayout";
import CommonMenu from "../../layout/CommonMenu";
import CommonFooter from "../../layout/CommonFooter";
import { useApplicationCommon } from "../../utils/ApplicationCommon";
import { Link } from "react-router-dom";

const GNBPURE00003S = () => {
  const { doAction } = useApplicationCommon(); // ✅ `doAction`만 사용
  const [searchKind, setSearchKind] = useState("1"); // 검색 유형 (제목/등록자)
  const [searchContents, setSearchContents] = useState(""); // 검색어
  const [isDepthOpen, setIsDepthOpen] = useState(false); // depth2 메뉴 열림 상태


  return (
    <CommonLayout>
      <CommonMenu />

      <div id="contents" className="container">

        <div className="sub-title bg-type01">
          <h2>기업소개</h2>
        </div>

        <div className="location_wrap"
          onClick={() => setIsDepthOpen(!isDepthOpen)}>
          <ul className="depth1">
            <li><Link to="/">home</Link></li>
            <li><Link to="/" onClick={(e) => e.preventDefault()}>오시는길<span></span></Link>
              <ul className="depth2" style={{ display: isDepthOpen ? "block" : "none" }}>
                <li><Link to="/GNBPURE00000S">CEO인사말</Link></li>
                <li><Link to="/GNBPURE00001S">ABOUT US</Link></li>
                <li><Link to="/GNBPURE03001S">우리회사소식</Link></li>
                <li><Link to="/GNBPURE00002S">사업실적</Link></li>
                <li><Link to="/GNBPURE00003S">오시는길</Link></li>
              </ul>
            </li>
          </ul>
        </div>
        <div id="cont" className="cont">
          <div className="inner">
            <h3>오시는길</h3>
            <div className="map_wrap">

              <div style={{ font: "normal normal 400 12px/normal dotum, sans-serif", color: "#333", position: "relative" }}>
                <div>
                  <Link to="https://map.kakao.com/?urlX=508172.0&urlY=1100848.0&itemId=277088896&q=%EC%A7%80%EC%95%A4%EB%B9%84%EC%86%8C%ED%94%84%ED%85%8D&srcid=277088896&map_type=TYPE_MAP&from=roughmap" target="_blank">
                    <img className="map" src="http://t1.daumcdn.net/roughmap/imgmap/51df248fd1d1775bd320510e7e19ac86ecf25c4cce4fc9d0b5edfa05cde9fd2e" style={{ border: "1px solid #ccc" }} />
                  </Link>
                </div>
                <div className="txt_wrap" style={{
                  overflow: "hidden",
                  padding: "7px 11px",
                  border: "1px solid rgba(0, 0, 0, 0.1)",
                  borderRadius: "0px 0px 2px 2px",
                  backgroundColor: "rgb(249, 249, 249)",
                  lineHeight: "22px"
                }}>
                  <Link className="kakao_img" to="https://map.kakao.com" target="_blank">
                    <img src="../../asset/img/subA/logo_kakaomap.png" alt="카카오맵" style={{ display: "block" }} />
                  </Link>
                  <div className="txt_inner">
                    <Link target="_blank" to="https://map.kakao.com/?from=roughmap&srcid=277088896&confirmid=277088896&q=%EC%A7%80%EC%95%A4%EB%B9%84%EC%86%8C%ED%94%84%ED%85%8D&rv=on">
                      로드뷰
                    </Link>
                    <span style={{ width: "1px", padding: "0", margin: "0 8px 0 9px", height: "16px", verticalAlign: "top", position: "relative", top: "2px", borderLeft: "1px solid #d0d0d0", float: "left" }}>
                    </span>
                    <Link target="_blank" to="https://map.kakao.com/?from=roughmap&eName=%EC%A7%80%EC%95%A4%EB%B9%84%EC%86%8C%ED%94%84%ED%85%8D&eX=508172.0&eY=1100848.0">
                      길찾기
                    </Link>
                    <span style={{ width: "1px", padding: "0", margin: "0 8px 0 9px", height: "16px", verticalAlign: "top", position: "relative", top: "2px", borderLeft: "1px solid #d0d0d0", float: "left" }}>
                    </span>
                    <Link target="_blank" to="https://map.kakao.com?map_type=TYPE_MAP&from=roughmap&srcid=277088896&itemId=277088896&q=%EC%A7%80%EC%95%A4%EB%B9%84%EC%86%8C%ED%94%84%ED%85%8D&urlX=508172.0&urlY=1100848.0">
                      지도 크게 보기
                    </Link>
                  </div>
                </div>
              </div>


            </div>
            <article>
              <p className="subtitle">GnB & Pure 본사</p>

              <ul className="box-address">
                <li className="address-inner">
                  <span>
                    ADDRESS
                  </span>
                  <p>
                    서울특별시 서초구 매헌로 16 하이브랜드몰 1519호
                  </p>
                </li>
                <li className="tel-inner">
                  <span>
                    TEL
                  </span>
                  <p>
                    02-3664-7014
                  </p>
                </li>
                <li className="fax-inner">
                  <span>
                    FAX
                  </span>
                  <p>
                    02-3664-7037
                  </p>
                </li>
              </ul>
            </article>
          </div>
        </div>
      </div>
      <CommonFooter />
    </CommonLayout >
  );
};

export default GNBPURE00003S;